module.exports = __webpack_public_path__ + "static/media/dumbell.14830fbd.svg";